/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { LazyImageStyle } from "@eisinc/MobiusOverrides/LazyImage";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface ParentCategoriesStyles {
    wrappingContainer?: InjectableCss;
    spinnerWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    wrapperCategoryLink?: InjectableCss;
    categoryImage?: InjectableCss;
    categoryText?: TypographyPresentationProps;
    categoryImageWrapper?: InjectableCss;
}

export const parentCategoriesStyles: ParentCategoriesStyles = {
    wrappingContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
        `,
    },
    spinnerWrapper: {
        css: css`
            width: 100%;
            position: relative;
            min-height: 80px;
        `,
    },
    spinner: {
        color: "primary.main",
        css: css`
            margin: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        `,
    },
    wrapperCategoryLink: {
        css: css`
            width: 100%;
            display: block;

            &:focus {
                outline: 0;
            }
        `,
    },
    categoryImageWrapper: {
        css: css`
            width: 100%;
            height: 175px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            margin-bottom: 10px;
            ${/* sc-selector */ LazyImageStyle} {
                width: 100%;
            }
        `,
    },
    categoryImage: {
        css: css`
            img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 175px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &:after {
                content: " ";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
                background: ${getColor("secondary.main")};
                opacity: 0;
                transition: all 0.2s linear;
            }

            &:hover,
            &:focus {
                &:after {
                    opacity: 0.2;
                }
            }
        `,
    },
    categoryText: {
        css: css`
            display: block;
            margin-bottom: 0;
            width: 100%;
            text-align: center;

            &:focus {
                outline: 0;
            }

            ${/* sc-selector */ TypographyStyle} {
                max-height: 45px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: pre-wrap;
                display: block;
            }

            &:hover,
            &:focus ${/* sc-selector */ TypographyStyle} {
                text-decoration: underline;
            }
        `,
    },
};
